import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import { useEffect, useState, useContext, useCallback } from 'react';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    // eslint-disable-next-line no-unused-vars
    refreshConversionStatus: (result: boolean) => void;
  }
}

export function fetchHasAvailableConversionGoals({
  CurrentAccount,
}) {
  const url = `/Customers(${CurrentAccount.AdvertiserCustomerID})/Accounts(${CurrentAccount.Id})/ConversionGoalDetails`;

  return odata.get(url, {
    path: 'Advertiser/V2',
  }).then(response => response.IsActiveConversionGoalPresent);
}

export const useHasConversionSetup = () => {
  const serverContext: any = useContext(ServerContext);
  const [hasConversionSetup, setHasConversionSetup] = useState<boolean | null>(null);

  useEffect(() => {
    fetchHasAvailableConversionGoals({
      CurrentAccount: serverContext.CurrentAccount,
    }).then((resp) => {
      setHasConversionSetup(resp);
    }).catch(() => {
      setHasConversionSetup(false);
    });
  }, [serverContext.CurrentAccount]);

  return { hasConversionSetup };
};

export const useCheckConversionGoalExists = ({
  hasConversionCallback,
}: {
  // eslint-disable-next-line no-unused-vars
  hasConversionCallback: (result: boolean) => void,
}) => {
  const serverContext: any = useContext(ServerContext);
  const refreshConversionStatus = useCallback(() => {
    if (document.visibilityState === 'visible') {
      fetchHasAvailableConversionGoals({
        CurrentAccount: serverContext.CurrentAccount,
      }).then((result) => {
        hasConversionCallback(result);
      });
    }
  }, [serverContext.CurrentAccount, hasConversionCallback]);

  useEffect(() => {
    document.addEventListener('visibilitychange', refreshConversionStatus);
    if (window.location.search.indexOf('isselenium=true') !== -1) {
      window.refreshConversionStatus = refreshConversionStatus;
    }
    return () => {
      document.removeEventListener('visibilitychange', refreshConversionStatus);
    };
  }, [refreshConversionStatus]);

  return {
    refreshConversionStatus,
  };
};
